import { routes } from 'router';

export const income_sources = Object.freeze({
  salary: 'Salary',
  wage: 'Wage',
  sassa_grant: 'Sassa grant',
  self_employed: 'Self employed',
});

export const income_frequencies = Object.freeze({
  weekly: 'Weekly',
  monthly: 'Monthly',
  commission: 'Commission',
});

export const applicationDefaults = Object.freeze({
  loanUsage: [
    { label: 'Housing/home improvement', value: 'housing' },
    { label: 'Education', value: 'education' },
    { label: 'Funeral', value: 'funeral' },
    { label: 'Emergency', value: 'emergency' },
    { label: 'I want to spoil myself', value: 'spoil_myself' },
    { label: 'Other', value: 'other' },
  ],

  loanTerms: [
    { label: '1 month', value: '1' },
    { label: '3 months', value: '3' },
    { label: '6 months', value: '6' },
    { label: '12 months', value: '12' },
    { label: '18 months', value: '18' },
    { label: '24 months', value: '24' },
    { label: '36 months', value: '36' },
    { label: '48 months', value: '48' },
    { label: '60 months', value: '60' },
    { label: '72 months', value: '72' },
  ],

  incomeSource: [
    { label: 'Salary', value: 'salary' },
    { label: 'Wage', value: 'wage' },
    { label: 'SASSA Grant', value: 'sassa-grant' },
    { label: 'Self Employed', value: 'self-employed' },
    { label: 'Unemployed', value: 'unemployed' },
  ],
  incomeFrequency: [
    { label: income_frequencies.weekly, value: 'weekly' },
    { label: income_frequencies.monthly, value: 'monthly' },
    { label: income_frequencies.commission, value: 'commission' },
  ],
  rejectionReason: [
    { label: 'The loan is not enough', value: '1' },
    { label: 'The installments are too high', value: '2' },
    { label: 'The loans are too expensive', value: '3' },
  ],
  applicationMethods: {
    // apply: 'apply-now', // Apply Now journey removed; only quick quote remains.
    quote: 'get-quote',
  },
  uploadMethods: {
    online: 'online',
    statement: 'statement',
  },
  issueTypes: [
    { label: 'Design issue', value: 'design-issue' },
    { label: 'Site is not usable', value: 'site-not-usable' },
    { label: 'Long loading times', value: 'long-loading-times' },
    { label: 'Links are broken', value: 'links-are-broken' },
    { label: 'Authentication issue', value: 'authentication-issue' },
    { label: 'Other please specify', value: 'other-please-specify' },
  ],
  operatingSystems: [
    { label: 'Mac OS', value: 'mac-os' },
    { label: 'Windows (32 bit)', value: 'windows-32-bit' },
    { label: 'Windows (64 bit)', value: 'windows-64-bit' },
    { label: 'Android', value: 'android' },
    { label: 'IOS', value: 'ios' },
    { label: 'Linux', value: 'linux' },
  ],
  browser: [
    { label: 'Google Chrome', value: 'google-chrome' },
    { label: 'Mozilla Firefox', value: 'mozilla-firefox' },
    { label: 'Safari', value: 'safari' },
    { label: 'Edge', value: 'edge' },
  ],
  homeUrl: 'https://vodalend.vodacom.co.za/compare/get-started',
  staticHomeUrl: 'https://www.vodacom.co.za/vodacom/services/financial-services/vodalend-compare',
  faqUrl:
    'https://www.vodacom.co.za/vodacom/services/financial-services/vodalend-compare/faqs?displayMode=Page',
  privacyUrl: 'https://www.vodacom.co.za/vodacom/terms/privacy-policy/payment-services',
  address: {
    maxLength: 255, // according to BillingStreet in Salesforce.
    /** @deprecated */
    provinces: [
      'Eastern Cape',
      'Free State',
      'Gauteng',
      'KwaZulu-Natal',
      'Limpopo',
      'Mpumalanga',
      'Northern Cape',
      'North West',
      'Western Cape',
    ],
    nullObject() {
      return /** @type {AddressInfo} */ ({
        streetAddress: '',
        city: '',
        postalCode: '',
        province: '',
        suburb: '',
        building: '',
      });
    },
  },
  business: {
    name: {
      maxLength: 23,
    },
    /** @deprecated */
    years: [
      { label: '0 - 1 years', value: '0' },
      { label: '1 - 2 years', value: '1' },
      { label: '2 - 5 years', value: '2' },
      { label: '5 - 10 years', value: '5' },
      { label: '10+ years', value: '10' },
    ],
  },
  personal: {
    firstName: {
      maxLength: 40,
    },
  },
  /** @deprecated */
  idTypes: [
    { key: 'id', value: 'RSA ID' },
    { key: 'pp', value: 'Passport' },
  ],
});

export const elementDefaults = Object.freeze({
  nullParagraphElement: /** @type {HTMLParagraphElement} */ (null),
  nullDivElement: /** @type {HTMLDivElement} */ (null),
});

export const errorMessages = Object.freeze({
  business: {
    positionMissing: 'Position in the company is invalid',
  },
  customer: {
    firstName: 'The first name entered is invalid',
    lastName: 'The last name name entered is invalid',
    mobileNumber: 'The mobile number entered is invalid',
    landlineNumber: 'The landline number entered is invalid',
    captcha: 'The captcha test failed. Please try again',
    title: 'Title is missing',
    rsaId: 'The ID number entered is invalid',
    rsaIdLength: 'The ID number is too short',
    passport: 'The passport number entered is invalid',
    email: 'The email entered is invalid',
  },
  email: {
    doublePunctuation: 'Double punctuation error',
    invalid: 'The email entered is invalid',
    maxLength: 'Address is above maximum length requirement',
    minLength: 'Address is below minimum length requirement',
    atSign: 'Missing @ sign',
    multipleAtSigns: 'Too many @ signs',
  },
  general: {
    loan: 'Missing loan term or usage',
    emptySuffix: 'cannot be empty',
    specialCharsSuffix: 'cannot have special characters',
    url: 'The URL entered is invalid',
    amount: 'The amount entered is invalid',
    employmentStatus: 'The employment status selected is invalid',
    employerName: 'The employer name entered is invalid',
    startDate: 'Please enter a valid year',
    employmentNumber: 'The employer contact number is invalid',
    employmentSector: 'The employment sector selected is invalid',
    employmentProvince: 'The province selected is invalid',
    incomeSource: 'Please select an income source',
    incomeFrequency: 'Please select an income frequency',
    grossIncome: 'The gross income entered is invalid',
    estimatedExpenses: 'The estimated expenses entered is invalid',
    issueType: 'Please select an issue type',
    operatingSystem: 'Please select an operating system',
    browser: 'Please select a browser',
    monthlyIncome: 'The monthly income entered is invalid',
    monthlyExpenses: 'The monthly expenses entered is invalid',
  },
  statement: {
    transactionHistory: 'Please upload a valid bank statement with 3 months transaction history.',
    startDate: 'Please upload a valid bank statement no older than 90 days.',
  },
  iam: {
    notFound: 'User does not exist',
    loginFailed: 'Login failed. Either the email address or password was incorrect.',
  },
  onboarding: {
    applicationNotFound: 'Onboarding application was not found.',
    userExists: 'A user with that email already exists.',
  },
  otp: {
    expired: 'OTP has expired - Resend a new OTP',
    incorrect: 'Incorrect OTP',
    tooManyAttempts: 'OTP attempts exceeded',
  },
  password: {
    empty: 'Password field cannot be empty',
    mismatch: 'Passwords do not match',
    minimumLength: 'Passwords must be 8 or more characters',
    unmetRules: 'Passwords must contain uppercase, lowercase and special characters',
  },
  technical: {
    general:
      "Uh oh! We're experiencing technical difficulties, but we're working on it. Please try again later.",
  },
});

export const lendingApplicationMessages = Object.freeze({
  actions: {
    updateApplication: 'UPDATE_APPLICATION',
    unchanged: 'NO_UPDATES',
  },
});

// TODO: these could probably all be joined up with the steps in create-account to create
// 1 cohesive source of steps, screens, and groupings.
export const lendingOnboardingSteps = Object.freeze({
  request: 'loan_request',
  personal_details: 'personal_details',
  offers_details: 'offers_details',
  accept_offer: 'accept_offer',
  offers_suggestions: 'offer_suggestions',
  thank_you: 'thank_you',
});

export const lendingOnboardingStepGroups = Object.freeze({
  request: 'Request',
  personal_details: 'Personal details',
  offers: 'Quotes',
});

export const storageKeys = Object.freeze({
  compare_application: 'compare_application',
  site_key: 'site_key',
});

export const applyNowPartners = Object.freeze({
  boodle: 'Boodle',
  finchoice: 'Finchoice',
  mpowa: 'MPOWA Finance',
});

export const allSteps = [
  {
    group: 'request',
    step: lendingOnboardingSteps.request,
    route: routes.loanRequest,
  },
  {
    group: 'personal_details',
    step: lendingOnboardingSteps.personal_details,
    route: routes.personalDetails,
  },

  {
    group: 'offers',
    step: lendingOnboardingSteps.offers_details,
    route: routes.offers,
  },
  {
    group: 'offers',
    step: lendingOnboardingSteps.offers_suggestions,
    route: routes.suggestions,
  },
  {
    group: 'offers',
    step: lendingOnboardingSteps.thank_you,
    route: routes.thankYou,
  },
];
